import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import NotFound from "./components/NotFound/NotFound";
import Login from "./components/Login/Login";
import AdminLayout from "./components/AdminLayout/AdminLayout";
import Home from "./components/Home/Home";
import Games from "./components/Games/Games";
import GameResult from "./components/Game Result/GameResult";
import AdManager from "./components/AdManager/AdManager";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import IstNavbar from "./components/IstNavbar/IstNavbar";
import IstPage from "./components/IstPage/IstPage";
import CustomMonthResult from "./components/CustomMonthResult/CustomMonthResult";
import Footer from "./components/Footer/Footer";
import Contact from "./components/Contact/Contact";

function App() {
  const [loggedin, setLoggedin] = useState(false);
  const updatelogin = () => { setLoggedin(!loggedin); };
  const location = useLocation();

  useEffect(() => {
    const logged = localStorage.getItem("loggedIn");
    setLoggedin(!!logged);
  }, []);

  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <>
      <ToastContainer />
      {!isAdmin && <IstNavbar />}

      <Routes>
        {/* ── Public routes ── */}
        <Route path="/" element={<IstPage />} />
        <Route path="/custommonthlychart" element={<CustomMonthResult />} />
        <Route path="/contact" element={<Contact />} />

        {/* ── Admin login ── */}
        {/* <Route path="/admin" element={<Login update={updatelogin} />} /> */}

        {/* ── Admin panel (protected) ── */}
        {loggedin && (
          <Route path="/admin/*" element={<AdminLayout update={updatelogin} />}>
            <Route path="home"        element={<Home />} />
            <Route path="games"       element={<Games />} />
            <Route path="gamesresult" element={<GameResult />} />
            <Route path="admanager"   element={<AdManager />} />
            <Route path="*"           element={<NotFound />} />
          </Route>
        )}

        {/* ── Global 404 Catch All ── */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      {!isAdmin && <Footer />}
    </>
  );
}

export default App;
